import React, { useEffect } from "react";
import { useData } from '../context/DataContext';
import { useNavigate } from 'react-router-dom';

function Logout() {
    const navigate = useNavigate();
    const { logout } = useData();

    useEffect(() => {
        logout();
        navigate('/login');
    }, [logout, navigate]);


    return (
        <div className="flex flex-col justify-center items-center w-full h-full" >
            <div>
                Logout
            </div>
        </div>
    );
}

export default Logout;
